var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Form_instances, _Form_validateSubmission, _Form_store, _Form_appendFormData, _Form_resetForm, _Form_analyticFb;
import $ from "jquery";
import "parsleyjs";
import '@/vendors/parsley';
export class Form {
    constructor(selector, ajaxSettings) {
        this.selector = selector;
        this.ajaxSettings = ajaxSettings;
        _Form_instances.add(this);
        this.csrfToken = $('meta[name="csrf-token"]').attr("content");
        __classPrivateFieldGet(this, _Form_instances, "m", _Form_validateSubmission).call(this);
    }
}
_Form_instances = new WeakSet(), _Form_validateSubmission = function _Form_validateSubmission() {
    $(this.selector).parsley({
        errorClass: 'is-invalid',
        errorsContainer: function (pEle) {
            return pEle.$element.siblings('.invalid-feedback');
        },
    });
    $(this.selector).on('submit', (event) => {
        if ($(event.target).parsley().isValid()) {
            __classPrivateFieldGet(this, _Form_instances, "m", _Form_store).call(this);
        }
        event.preventDefault();
    });
}, _Form_store = function _Form_store() {
    const $form = $(this.selector);
    const $btnSubmit = $form.find('button[type="submit"]');
    let formData = new FormData($form[0]);
    //////////////////////////////////////////////////////////////////
    // loading state
    $form.addClass('is-submitting');
    $btnSubmit.prop('disabled', true);
    //////////////////////////////////////////////////////////////////
    // append additional form data
    formData = __classPrivateFieldGet(this, _Form_instances, "m", _Form_appendFormData).call(this, formData);
    if (this.ajaxSettings.onLoading) {
        const onLoading = this.ajaxSettings.onLoading(formData);
        if (typeof onLoading === 'object') {
            formData = onLoading.formData;
        }
    }
    $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: formData,
        enctype: 'multipart/form-data',
        headers: {
            "X-CSRF-TOKEN": this.csrfToken,
        },
        processData: false,
        contentType: false,
        success: (data, status) => {
            __classPrivateFieldGet(this, _Form_instances, "m", _Form_resetForm).call(this);
            __classPrivateFieldGet(this, _Form_instances, "m", _Form_analyticFb).call(this);
            if (this.ajaxSettings.onSuccess) {
                this.ajaxSettings.onSuccess(data, status);
            }
        },
        error: (data, status) => {
            if (this.ajaxSettings.onError) {
                this.ajaxSettings.onError(data, status);
            }
        },
        complete: () => {
            $form.removeClass('is-submitting');
            $btnSubmit.prop('disabled', false);
            if (this.ajaxSettings.onComplete) {
                this.ajaxSettings.onComplete();
            }
        }
    });
}, _Form_appendFormData = function _Form_appendFormData(formData) {
    formData.append('language', $('html').attr('lang'));
    formData.append('page_url', window.location.href);
    return formData;
}, _Form_resetForm = function _Form_resetForm() {
    const $form = $(this.selector);
    $form.trigger('reset');
    $form.find('select').trigger('change');
    $form.find('.form-float').removeClass('focus');
    $form.find('.fileupload-filename').empty();
}, _Form_analyticFb = function _Form_analyticFb() {
    if (typeof window.fbq !== 'undefined') {
        window.fbq('track', 'Lead', {
            value: 1,
            currency: '1',
        });
    }
};
